(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  class SlideshowHero {
    constructor(el) {
      this.el          = el;
      this.slides      = Array.from(el.querySelectorAll('.ss-hero__slide'));
      this.progItems   = Array.from(el.querySelectorAll('.ss-hero__prog-item'));
      this.counterCur  = el.querySelector('.ss-hero__counter-cur');
      this.prevBtn     = el.querySelector('.ss-hero__arrow--prev');
      this.nextBtn     = el.querySelector('.ss-hero__arrow--next');
      this.total       = this.slides.length;
      this.current     = 0;
      this.autoplay    = el.dataset.autoplay === 'true';
      this.speed       = parseInt(el.dataset.speed, 10) || 5000;
      this.timer       = null;
      this.touchStartX = 0;

      if (this.total < 2) return;

      var outer = el.closest('.ss-hero__outer');
      if (outer) outer.style.setProperty('--ss-speed', this.speed + 'ms');

      this._bind();
      if (this.autoplay) this._startTimer();
    }

    _bind() {
      this.prevBtn.addEventListener('click', () => this._move(-1));
      this.nextBtn.addEventListener('click', () => this._move(1));

      this.progItems.forEach((item, i) => {
        item.addEventListener('click', () => this._goTo(i));
      });

      this.el.addEventListener('touchstart', (e) => {
        this.touchStartX = e.touches[0].clientX;
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        var diff = this.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) this._move(diff > 0 ? 1 : -1);
      });

      document.addEventListener('keydown', (e) => {
        if (!this._isInView()) return;
        if (e.key === 'ArrowLeft')  this._move(-1);
        if (e.key === 'ArrowRight') this._move(1);
      });
    }

    _move(dir) {
      this._goTo((this.current + dir + this.total) % this.total);
    }

    _goTo(index) {
      if (index === this.current) return;
      this.current = index;

      this.slides.forEach((s, i) =>
        s.classList.toggle('is-active', i === this.current)
      );

      this.progItems.forEach((item, i) => {
        var fill = item.querySelector('.ss-hero__prog-fill');
        item.classList.remove('is-active', 'is-done');

        if (i < this.current) {
          item.classList.add('is-done');
          fill.style.animation = 'none';
        } else if (i === this.current) {
          item.classList.add('is-active');
          fill.style.animation = 'none';
          void fill.offsetHeight;
          fill.style.animation = '';
        } else {
          fill.style.animation = 'none';
        }
      });

      this._updateCounter();
      if (this.autoplay) this._resetTimer();
    }

    _updateCounter() {
      if (!this.counterCur) return;
      var n = this.current + 1;
      this.counterCur.textContent = n < 10 ? '0' + n : String(n);
    }

    _startTimer() {
      this.timer = setInterval(() => this._move(1), this.speed);
    }

    _resetTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this._move(1), this.speed);
    }

    _isInView() {
      var r = this.el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }
  }

  document.querySelectorAll('.ss-hero').forEach(function (el) {
    new SlideshowHero(el);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
